export { default as BravoDeluxe } from '@/assets/graphics/specialHotelTypes/bravoConceptDeluxe.svg';
export { default as BravoDuo } from '@/assets/graphics/specialHotelTypes/bravoConceptDuo.svg';
export { default as BravoFavorit } from '@/assets/graphics/specialHotelTypes/bravoConceptFavorite.svg';
export { default as BravoLokal } from '@/assets/graphics/specialHotelTypes/bravoConceptLocal.svg';
export { default as BravoUnik } from '@/assets/graphics/specialHotelTypes/bravoConceptUnique.svg';
export { default as HeartHotel } from '@/assets/graphics/specialHotelTypes/heartHotel.svg';
